import * as angular from "angular";
import template from "./entity-products-tab.html";
import type { ModalTabItem } from "../../../modals/tabbed-modal/tabbed-modal-types";
import { globs } from "../../../../services/globs";
import { isSupportedOrNullish } from "../../isSupportedOrNullish";
import type {
	EntityModel,
	EntityTypeConfig
} from "./entityModalTabTypes";

export interface EntityProductsTabController {
	entity?: EntityModel;
	typeConfig: EntityTypeConfig;
}

// eslint-disable-next-line no-redeclare
export class EntityProductsTabController {
	public static $inject = ["securityService"];

	public tab!: ModalTabItem;

	public constructor(private readonly securityService) {}

	public $onInit(): void {
		const canViewProducts = globs.entityTypes.byType(this.typeConfig.Code).products.byCode("*").read;
		this.tab = {
			name: "Products",
			code: "PRODUCTS",
			isAvailable: !!(
				this.securityService.isActionOrPatternAllowed(canViewProducts)
				&& isSupportedOrNullish(this.typeConfig.Products)
			)
		};
	}
}

export default angular
	.module("vesl.components.entity-modal.tabs.entity-products-tab", [])
	.component("entityProductsTab", {
		controller: EntityProductsTabController,
		template,
		bindings: {
			entity: "<",
			typeConfig: "<"
		}
	})
	.name;
